/**
 * @file StatusPill.tsx
 * @description Статус-пилюля кабинета магазина по реестру `lib/shop/status-meta`
 * (phase19.31, шаг О4; SC25): точка + текст, один из шести тонов.
 *
 * Страница не выбирает цвет — передаёт запись реестра (`meta`) или тон с
 * подписью. Вид пилюли (точка, скругление, шрифт 12/500) задаёт тема по
 * `data-slot="badge"` и варианту.
 *
 * ```tsx
 * <StatusPill meta={PICKING_STATUS_META[task.status]} />
 * <StatusPill tone="attention">Скоро истекает</StatusPill>
 * ```
 */

import type { ReactNode } from "react";

import { Badge } from "./badge";
import { STATUS_TONE_VARIANT, type ShopStatusMeta, type StatusTone } from "@/lib/shop/status-meta";

type Props =
  | { meta: ShopStatusMeta; tone?: never; children?: never; className?: string }
  | { meta?: never; tone: StatusTone; children: ReactNode; className?: string };

export function StatusPill(props: Props) {
  const tone = props.meta ? props.meta.tone : props.tone;
  const label = props.meta ? props.meta.label : props.children;
  return (
    <Badge variant={STATUS_TONE_VARIANT[tone]} data-status-tone={tone} className={props.className}>
      {label}
    </Badge>
  );
}
